import React, { useEffect, useState } from "react";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import HttpService from "../../services/httpService";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TableContainer,
    makeStyles,
    Modal,
    Backdrop,
    Fade,
    Typography,
    IconButton,
    CircularProgress
} from "@material-ui/core";
import { FormControl, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";
import { CSVLink } from "react-csv";
import Button from "@material-ui/core/Button";
import DownloadIcon from "@material-ui/icons/GetApp";
import RefreshIcon from "@material-ui/icons/Refresh";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { useRef } from "react";
import moment from "moment";
import { DownloadOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { setCPDData } from "../../redux/actions/leadSourceActions";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),     // top spacing
        marginBottom: theme.spacing(2),  // bottom spacing
        color: theme.palette.text.secondary,
    },

    submitButton: {
        backgroundColor: "#FFA726", // light orange
        color: "#fff",
        borderRadius: 20,           // curved edges
        textTransform: "none",
        padding: "8px 24px",
        "&:hover": {
            backgroundColor: "#FB8C00",
        },
    },

    container: {
        maxHeight: 500,
        overflow: "auto"
    },

    tableHead: {
        backgroundColor: "#3f51b5"
    },

    headCell: {
        color: "#fff",
        fontWeight: "bold",
        textAlign: "center",
        position: "sticky",
        top: 0,
        backgroundColor: "#3f51b5",
        zIndex: 3
    },

    monthHeaderCell: {
        left: 0,
        zIndex: 4
    },

    monthCell: {
        fontWeight: "bold",
        backgroundColor: "#f4f6fb",
        position: "sticky",
        left: 0,
        zIndex: 2
    },

    clickableCell: {
        color: "#3f51b5",
        fontWeight: 600,
        textDecoration: "underline",
        cursor: "pointer",
        textAlign: "center",
        "&:hover": {
            backgroundColor: "#eef1ff"
        }
    }
}));

const ChannelPartner = (props) => {
    const classes = useStyles();
    const cpdData = useSelector((state) => state.leadSource.cpdData);
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedCell, setSelectedCell] = useState(null);
    const [storeDateFilter, setPivotDateFilters] = useState({ startDate: "", endDate: "" })
    const [sources, setSources] = useState([])
    const [selectedSourceOfLead, setSelectedSourceOfLead] = useState([])
    const [dataPopup, setDataPopup] = useState([]);
    const [popupMeta, setPopupMeta] = useState({
        stage: "",
        month: ""
    });


    const [lastUsedParams, setLastUsedParams] = useState(null);
    const [isInitialRender, setIsInitialRender] = useState(true);
    const SIXTH_BUTTON_DISABLE_UNTIL_KEY = 'sixthButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);

    const [modalLoading, setModalLoading] = useState(false);
    const [page, setPage] = useState(0);
    const rowsPerPage = 100;

    const [search, setSearch] = useState("");

    const csvButtonRef = useRef(null);
    const totalCSVButtonRef = useRef(null);
    const [channelPartnerTableCsvData, setChannelPartnerTableCsvData] = useState([]);
    const channelPartnerTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [isDownload, setIsDownload] = useState(false);
    const headers = [
        { label: "Lead Id", key: "_id" },
        { label: "Lead No", key: "leadNo" },
        { label: "Client Name", key: "clientName" },
        // { label: "Client Number", key: "clientNumber" },
        // { label: "Client Email", key: "clientEmail" },
        { label: "Created At", key: "createdAt" },
        { label: "Source Of Lead", key: "sourceOfLead" },
        { label: "City", key: "city" },
        { label: "Experience Center", key: "experienceCenter" },
        { label: "Current Stage", key: "currentStage" },
        { label: "Department", key: "department" },
        { label: "Channel Partner Stage", key: "channelPartnerStage" },
        { key: "projectNeeds", label: "SOW" },
        { key: "threeLakhsSuits", label: "Three Lakh Suits" },
        { key: "startProjectBy", label: "Start Project By" },
    ];

    const csvData = dataPopup.map((lead) => ({
        _id: lead._id || "-",
        leadNo: lead.lead_no || "-",
        clientName: lead.customerId?.name || "-",
        // clientNumber: lead.customerId?.contact_no || "-",
        // clientEmail: lead.customerId?.email || "-",
        createdAt: lead.createdAt
            ? new Date(lead.createdAt).toLocaleDateString()
            : "-",
        sourceOfLead: lead.sourceOfLead?.name || "-",
        city: lead.city?.name || "-",
        experienceCenter: lead.experienceCenterId?.name || "-",
        currentStage: lead.currentStage || "-",
        department: lead.departmentId?.name || "-",
        channelPartnerStage: lead?.channelPartnerStage || "-",
        projectNeeds: lead?.projectNeeds || "-",
        threeLakhsSuits: lead?.threeLakhsSuits || "-",
        startProjectBy: lead?.startProjectBy || "-",
    }));

    const csvDownloadHandler = () => {
        if (!dataPopup.length) return;
        csvButtonRef.current.link.click();
    };

    useEffect(() => {
        channelPartner();
        getSourceOfLeads();
    }, []);

    useEffect(() => {
        setPage(0);
    }, [dataPopup, search]);

    // Trigger CSV download when data is ready
    useEffect(() => {
        if (triggerDownload && channelPartnerTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (channelPartnerTableCsvButtonRef.current?.link) {
                    try {
                        channelPartnerTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerDownload(false);
                } else {
                    setTimeout(() => {
                        if (channelPartnerTableCsvButtonRef.current?.link) {
                            channelPartnerTableCsvButtonRef.current.link.click();
                            setTriggerDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [triggerDownload, channelPartnerTableCsvData]);

    // Function to generate CSV data for Channel Partner table
    const generateChannelPartnerTableCsvData = () => {
        try {
            if (!data || data.length === 0) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "Month": "",
                "Total Leads": "",
                "No. Of Meetings": "",
                "Sold": "",
                "Active Leads - Sales Pipeline": "",
                "Active Leads - Marketing Pipeline": "",
                "Hold": "",
                "Junk": "",
                "Lost": ""
            };
            csvRows.push(headerRow);

            // Add data rows
            data.forEach((item) => {
                const row = {
                    "Month": item.month || "",
                    "Total Leads": item?.total?.count ?? 0,
                    "No. Of Meetings": item?.meetings?.count ?? 0,
                    "Sold": item?.sold?.count ?? 0,
                    "Active Leads - Sales Pipeline": item?.salesPipeline?.count ?? 0,
                    "Active Leads - Marketing Pipeline": item?.marketingPipeline?.count ?? 0,
                    "Hold": item?.hold?.count ?? 0,
                    "Junk": item?.junk?.count ?? 0,
                    "Lost": item?.lost?.count ?? 0
                };
                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating channel partner table CSV:", error);
            return [];
        }
    };

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const channelPartner = async (addSources) => {
        let sourcesData = addSources?.map((el) => el.name)

        let currentObj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedSources: sourcesData ? sourcesData : "",
        }
        // try {
        //     let obj = {
        //         startDate: storeDateFilter.startDate,
        //         endDate: storeDateFilter.endDate,
        //         selectedSources: sourcesData ? sourcesData : "",
        //     }
        //     setLoading(true);
        //     const response = await HttpService.getChannelPartnerDashboard(obj);
        //     setData(response?.data?.data || []);
        // } catch (error) {
        //     console.error("Dashboard Error", error);
        // } finally {
        //     setLoading(false);
        // }
        let shouldMakeApiCall = false;

        // Case 1: No lgdData - must call API
        if (!cpdData || cpdData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoading(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getChannelPartnerDashboard(currentObj);
                setData(response?.data?.data || []);
                dispatch(setCPDData(response?.data?.data || []));
            } else {
                // Use existing data
                setData(cpdData);
            }

            // Always save the current parameters
            setLastUsedParams({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRender) {
                setIsInitialRender(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        setLoading(false);
    };

    // Add this effect to initialize state from localStorage and handle timer
    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(SIXTH_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeft(remainingTimeInSeconds);
                setIsDisabled(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(SIXTH_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                setTimeLeft(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(SIXTH_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    // Format time for display
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(SIXTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinning(true);
        getRefreshedData();
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
    };

    const getRefreshedData = async (addSources = []) => {
        const sourcesData = Array.isArray(addSources)
            ? addSources.map(el => el.name)
            : [];

        try {
            const obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedSources: sourcesData,
            };

            setLoading(true);
            const response = await HttpService.getChannelPartnerDashboard(obj);
            setData(response?.data?.data || []);
            dispatch(setCPDData(response?.data?.data || []));
        } catch (error) {
            console.error("Dashboard Error", error);
        } finally {
            setLoading(false);
        }
    };

    const getDataChannelPartner = async ({ leadIds, stage, month, sources }) => {
        let sourcesData = sources?.map((el) => el.name);

        try {

            const obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedSources: sourcesData || "",
                leadIds,
                stage,
                month
            };

            // IF TOTAL → NO MODAL AT ALL
            if (stage === "total") {
                props.setLoading(true);
                const response = await HttpService.channelPartnerData(obj);
                const result = response?.data?.data || [];

                const formattedData = result.map((lead, index) => ({
                    sl: index + 1,
                    _id: lead?._id || "-",
                    leadNo: lead?.lead_no || "-",
                    clientName: lead.customerId?.name || "-",
                    // clientNumber: lead.customerId?.contact_no || "-",
                    // clientEmail: lead.customerId?.email || "-",
                    createdAt: lead?.createdAt
                        ? moment(lead.createdAt).format("DD-MM-YYYY")
                        : "-",
                    sourceOfLead: lead.sourceOfLead?.name || "-",
                    city: lead.city?.name || "-",
                    experienceCenter: lead.experienceCenterId?.name || "-",
                    currentStage: lead.currentStage || "-",
                    department: lead.departmentId?.name || "-",
                    channelPartnerStage: lead?.channelPartnerStage || "-",
                }));

                setDataPopup(formattedData);
                setIsDownload(true);
                props.setLoading(false);

                // trigger download
                // setTimeout(() => {
                //     if (formattedData.length) {
                //         csvButtonRef.current.link.click();
                //     }
                // }, 0);

                return; // STOP HERE (no modal logic runs)
            }

            // FOR OTHER STAGES → OPEN MODAL
            setModalOpen(true);
            setPopupMeta({ stage, month });
            setDataPopup([]);
            setModalLoading(true);

            const response = await HttpService.channelPartnerData(obj);
            const result = response?.data?.data || [];

            setDataPopup(result);
        } catch (error) {
            console.error("Channel Partner data error", error);
        } finally {
            setModalLoading(false);
        }
    };

    useEffect(() => {
        if (isDownload && dataPopup?.length && totalCSVButtonRef.current?.link) {
            totalCSVButtonRef.current.link.click();
            setIsDownload(false);
        }
    }, [dataPopup, isDownload]);

    const getSourceOfLeads = async () => {
        try {
            const response = await HttpService.getLeadMaster()

            const channelPartnerSources = response.data.filter(
                (item) => item.sourceType === "Channel Partner"
            );
            setSources(channelPartnerSources);
        } catch (error) {
            console.error(
                "Error fetching source of leads:",
                error?.response?.data || error.message
            );
        }
    };

    const handlePivotDateFilter = () => {
        const { startDate, endDate } = storeDateFilter;

        if (!startDate || !endDate) {
            props.setSnackInfo("Please select both start and end date", "warning");
            return;
        }

        const start = new Date(startDate);
        const end = new Date(endDate);

        const diffInDays = (end - start) / (1000 * 60 * 60 * 24);

        if (diffInDays > 31) {
            props.setSnackInfo("Data fetching range is too large. Please select a date range within 1 month.", "warning");
            return;
        }

        // proceed with fetching
        channelPartner(selectedSourceOfLead);
    };

    const handleCellClick = (month, stage, stageData) => {
        if (loading) return;

        setSelectedCell({
            month,
            stage,
            count: stageData?.count || 0,
            leads: stageData?.leads || []
        });
        setModalOpen(true);
    };
    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDateFilters({ ...storeDateFilter, [name]: value })
    }

    const handleMultipleSourceOfLead = (event, newValue) => {
        setSelectedSourceOfLead(newValue)
        handleSourceOfLead(newValue)
    }

    const handleSourceOfLead = async (newValue) => {
        // props.setLoading(true);
        await channelPartner(newValue)
        // props.setLoading(false);
    }

    const filteredData = dataPopup.filter((lead) =>
        (lead.lead_no + "").includes(search) ||
        (lead.customerId?.name || "").toLowerCase().includes(search.toLowerCase())
    );
    const paginatedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const handleCloseModal = () => {
        setModalOpen(false);
        setPage(0);
        setSearch("")
    };

    const renderCell = (item, stageKey) => {
        const leadIds =
            item?.[stageKey]?.leads?.map(l => l.leadId) || [];

        const count = item?.[stageKey]?.count ?? 0;

        return (
            <TableCell
                className={classes.clickableCell}
                onClick={() =>
                    getDataChannelPartner({
                        leadIds,
                        stage: stageKey,
                        month: item.month,
                        sources: selectedSourceOfLead
                    })
                }
            >
                <div style={{ display: "flex", alignItems: "center", gap: 6, justifyContent: "center" }}>

                    {/* Show icon only for total */}
                    {stageKey === "total" && (
                        <DownloadOutlined style={{ fontSize: 16 }} />
                    )}

                    {count}
                </div>
            </TableCell>
        );
    };

    const renderSkeletonRows = () =>
        Array.from({ length: 2 }).map((_, index) => (
            <TableRow key={index}>
                {/* Month */}
                <TableCell className={classes.monthCell}>
                    <Skeleton width={80} />
                </TableCell>

                {/* Other columns */}
                {Array.from({ length: 7 }).map((_, i) => (
                    <TableCell key={i} align="center">
                        <Skeleton width={30} />
                    </TableCell>
                ))}
            </TableRow>
        ));

    return (
        <>
            <>
                {/* MAIN CONTAINER */}
                <Paper className={classes.container} style={{ padding: "20px" }}>

                    {/* TOP BAR */}
                    <div
                        style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: "20px"
                        }}
                    >
                        {/* CENTER HEADING */}
                        <h2 style={{ margin: 0, fontWeight: 600 }}>
                            Channel Partner Dashboard
                        </h2>

                        {/* RIGHT BUTTON */}
                        <Button
                            onClick={handleRefreshClick}
                            variant="contained"
                            startIcon={<RefreshIcon />}
                            disabled={isDisabled}
                            style={{
                                position: "absolute",
                                right: 0,
                                backgroundColor: isDisabled ? "#cccccc" : "#F47E46",
                                color: "#FFF2EB",
                                height: "36px",
                                textTransform: "none"
                            }}
                        >
                            {isDisabled
                                ? `Wait (${formatTimeLeft()})`
                                : "Fetch New Data"}
                        </Button>
                    </div>

                    {/* FILTER SECTION */}
                    <Paper
                        className={classes.paper}
                        style={{
                            padding: "20px",
                            marginBottom: "20px",
                            borderRadius: "12px",
                            background: "#fafafa",
                            border: "1px solid #eee"
                        }}
                    >
                        <Grid container spacing={2} alignItems="center">

                            {/* Source of Lead */}
                            <Grid item xs={12} sm={3}>
                                <FormControl fullWidth size="small">
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        value={selectedSourceOfLead}
                                        onChange={handleMultipleSourceOfLead}
                                        options={sources}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Source of Lead"
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            {/* From Date */}
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    name="startDate"
                                    label="CreatedAt From Date"
                                    type="date"
                                    size="small"
                                    variant="outlined"
                                    value={storeDateFilter.startDate}
                                    onChange={storePivotDate}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>

                            {/* To Date */}
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    name="endDate"
                                    label="CreatedAt To Date"
                                    type="date"
                                    size="small"
                                    variant="outlined"
                                    value={storeDateFilter.endDate}
                                    onChange={storePivotDate}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>

                            {/* Submit */}
                            <Grid item xs={12} sm={2}>
                                <Button
                                    variant="contained"
                                    onClick={handlePivotDateFilter}
                                    fullWidth
                                    style={{
                                        backgroundColor: "#F47E46",
                                        color: "#FFF2EB",
                                        borderRadius: 20,
                                        height: "40px",
                                        textTransform: "none",
                                        fontWeight: 500
                                    }}
                                >
                                    Submit
                                </Button>
                            </Grid>

                        </Grid>
                    </Paper>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', marginTop: '20px' }}>
                        <CSVLink
                            data={channelPartnerTableCsvData}
                            filename={`Channel_Partner_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                            ref={channelPartnerTableCsvButtonRef}
                            style={{ textDecoration: 'none', display: 'none' }}
                        />
                        <Button
                            variant='contained'
                            size="small"
                            startIcon={<DownloadOutlined />}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                const csvData = generateChannelPartnerTableCsvData();

                                if (csvData.length > 0) {
                                    setChannelPartnerTableCsvData(csvData);
                                    setTimeout(() => {
                                        setTriggerDownload(true);
                                    }, 100);
                                } else {
                                    props.setSnackInfo("No data available to export", "warning");
                                }
                            }}
                            style={{
                                backgroundColor: "#355025",
                                color: "#FFF2EB",
                                padding: "0.2rem 1rem",
                                fontSize: '0.75rem'
                            }}
                        >
                            Download CSV
                        </Button>
                    </div>
                    {/* TABLE SECTION */}
                    <TableContainer component={Paper} className={classes.container}>
                        <Table stickyHeader>
                            {/* HEADER */}
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        className={`${classes.headCell} ${classes.monthHeaderCell}`}
                                    >
                                        CreatedAt Month
                                    </TableCell>
                                    <TableCell className={classes.headCell}>Total Leads</TableCell>
                                    <TableCell className={classes.headCell}>No. Of Meetings</TableCell>
                                    <TableCell className={classes.headCell}>Sold</TableCell>
                                    <TableCell className={classes.headCell}>Active Leads - Sales Pipeline</TableCell>
                                    <TableCell className={classes.headCell}>Active Leads - Marketing Pipeline</TableCell>
                                    <TableCell className={classes.headCell}>Hold</TableCell>
                                    <TableCell className={classes.headCell}>Junk</TableCell>
                                    <TableCell className={classes.headCell}>Lost</TableCell>
                                </TableRow>
                            </TableHead>

                            {/* BODY */}
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={8} // total number of columns
                                            align="center"
                                            style={{ padding: "30px" }}
                                        >
                                            <CircularProgress size={30} />
                                        </TableCell>
                                    </TableRow>
                                ) : (data.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell className={classes.monthCell}>
                                            {item.month}
                                        </TableCell>
                                        {renderCell(item, "total")}
                                        {renderCell(item, "meetings")}
                                        {renderCell(item, "sold")}
                                        {renderCell(item, "salesPipeline")}
                                        {renderCell(item, "marketingPipeline")}
                                        {renderCell(item, "hold")}
                                        {renderCell(item, "junk")}
                                        {renderCell(item, "lost")}
                                    </TableRow>
                                ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </>

            <CSVLink
                headers={headers}
                filename={`channel_partner_${moment().format("DD_MM_YYYY")}.csv`}
                data={dataPopup}
                ref={totalCSVButtonRef}
            />

            {/* MODAL */}
            <Modal
                open={modalOpen}
                onClose={handleCloseModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 300,
                    style: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                        backdropFilter: "blur(4px)"
                    }
                }}
            >
                <Fade in={modalOpen}>
                    <div
                        style={{
                            width: "95%",
                            height: "90vh",
                            margin: "auto",
                            marginTop: "2%",
                            background: "#fff",
                            borderRadius: 12,
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >

                        {/* HEADER */}
                        <div
                            style={{
                                padding: "15px 20px",
                                background: "linear-gradient(90deg, #4f46e5, #9333ea)",
                                color: "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <div>
                                <Typography style={{ fontWeight: 600 }}>
                                    {popupMeta.stage} – {popupMeta.month}
                                </Typography>
                                <Typography style={{ fontSize: 12 }}>
                                    {filteredData.length} leads found
                                </Typography>
                            </div>

                            <div style={{ display: "flex", gap: 10 }}>
                                <CSVLink
                                    headers={headers}
                                    filename={`channel_partner_${popupMeta.stage}_${popupMeta.month}.csv`}
                                    data={csvData}
                                    ref={csvButtonRef}
                                >
                                    <Button
                                        startIcon={<GetAppIcon />}
                                        style={{ color: "#fff", border: "1px solid #fff" }}
                                    >
                                        Export
                                    </Button>
                                </CSVLink>

                                <IconButton onClick={handleCloseModal} style={{ color: "#fff" }}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>

                        {/* SEARCH */}
                        <div style={{ padding: 15 }}>
                            <TextField
                                placeholder="Search leads..."
                                variant="outlined"
                                size="small"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{ width: 300 }}
                            />
                        </div>

                        {/* TABLE / LOADER */}
                        <div
                            id="modalTableContainer"
                            style={{ flex: 1, overflow: "auto", position: "relative" }}
                        >

                            {modalLoading ? (
                                <div
                                    style={{
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <CircularProgress size={50} />
                                </div>
                            ) : filteredData.length === 0 ? (
                                <p style={{ textAlign: "center", marginTop: 20 }}>
                                    No leads found
                                </p>
                            ) : (
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {[
                                                "#",
                                                "Lead No",
                                                "Client",
                                                "Created At",
                                                "Source",
                                                "City",
                                                "Experience Center",
                                                "Current Stage",
                                                "Department",
                                                "Channel Partner Stage"
                                            ].map((head, i) => (
                                                <TableCell
                                                    key={i}
                                                    style={{
                                                        background: "#2f4b8f",
                                                        color: "#fff",
                                                        fontWeight: 600,
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    {head}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {paginatedData.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell component="th" align="center">
                                                    {page * rowsPerPage + index + 1}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.lead_no ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{
                                                                color: "#1C375D",
                                                                textDecoration: "underline",
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            {data.lead_no}
                                                        </Link>
                                                    ) : (
                                                        "NA"
                                                    )}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.customerId?.name || "NA"}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.createdAt
                                                        ? moment(data.createdAt).format("DD-MM-YYYY")
                                                        : "NA"}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.sourceOfLead?.name || "NA"}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.city?.name || "NA"}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.experienceCenterId?.name || "NA"}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.currentStage || "NA"}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.departmentId?.name || "NA"}
                                                </TableCell>

                                                <TableCell component="th" align="center">
                                                    {data?.channelPartnerStage || "NA"}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )}
                        </div>

                        {/* FOOTER (PAGINATION) */}
                        {!modalLoading && filteredData.length > 0 && (
                            <div
                                style={{
                                    padding: 10,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Typography style={{ fontSize: 12 }}>
                                    Showing {page * rowsPerPage + 1} -{" "}
                                    {Math.min((page + 1) * rowsPerPage, filteredData.length)} of{" "}
                                    {filteredData.length}
                                </Typography>

                                <div>
                                    <IconButton
                                        disabled={page === 0}
                                        onClick={() => setPage((p) => p - 1)}
                                    >
                                        <ArrowBackIosIcon fontSize="small" />
                                    </IconButton>

                                    <span style={{ margin: "0 10px" }}>
                                        Page {page + 1} of{" "}
                                        {Math.ceil(filteredData.length / rowsPerPage)}
                                    </span>

                                    <IconButton
                                        disabled={(page + 1) * rowsPerPage >= filteredData.length}
                                        onClick={() => setPage((p) => p + 1)}
                                    >
                                        <ArrowForwardIosIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>
                        )}
                    </div>
                </Fade>
            </Modal>
        </>
    );
};

export default connect(null, { setLoading, setSnackInfo })(ChannelPartner);
